import Cookie from 'js-cookie';
import config from '../config/environments';

export const clearInfo = () => {
	localStorage.removeItem('token');
	localStorage.removeItem('loggedFrom');
	Cookie.remove('CockpitLogged', { domain: '.webmotors.com.br' });
	Cookie.remove('Token');
};

export const fromLoginForm = () => localStorage.getItem('loggedFrom');

export const logoutUser = () => {
	const inBackoffice = window.location.pathname.split('/')
		.includes('backoffice');
	window.location.href = fromLoginForm() || inBackoffice
		? '/logout' : `${config.cockpitUrl}/logout`;
};

const auth = {
	clearInfo,
	fromLoginForm,
	logoutUser,
};

export default auth;
